import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

interface IProps {
  quantity: number;
  sx?: SxProps<Theme>;
}

export const QuantityChip: React.FC<IProps> = ({ quantity, sx }) => {
  return (
    <Box
      aria-hidden
      sx={{
        flexShrink: 0,
        width: 24,
        height: 24,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) =>
          `color-mix(in srgb, ${theme.palette.primary.main} 4%, ${theme.palette.background.paper})`,
        fontWeight: 400,
        fontSize: 12,
        lineHeight: 1.66,
        color: 'common.black',
        fontVariantNumeric: 'tabular-nums',
        ...sx,
      }}
    >
      x{quantity}
    </Box>
  );
};
